import React from "react";
import {
  FaUtensils,
  FaBed,
  FaBath,
  FaCouch,
  FaDoorOpen,
  FaChild,
  FaTv,
  FaCloudSun,
  FaHome,
  FaChair,
  FaPaintBrush,
  FaDrawPolygon,
  FaLayerGroup,
  FaPalette,
  FaWindowMaximize,
  FaRulerCombined,
  FaChalkboardTeacher,
  FaWineGlassAlt,
  FaBoxes,
  FaCubes,
  FaBorderStyle,
  FaBoxOpen,
} from "react-icons/fa";
import { GiStairs } from "react-icons/gi";
import "./HomeServices.css";

const HomeServices = () => {
  // const animations = ["glow-bg", "wave-bg", "shimmer-bg", "particle-bg"];
  const animations = [ "shimmer-bg", "particle-bg"];

  const services = [
    { title: "Modular Kitchen Designs", desc: "Smart, space-efficient kitchen layouts with premium finishes.", icon: <FaUtensils /> },
    { title: "Wardrobe Designs", desc: "Stylish wardrobes designed for elegance and storage.", icon: <FaBoxes /> },
    { title: "Bathroom Designs", desc: "Luxurious bathrooms designed with comfort and aesthetics.", icon: <FaBath /> },
    { title: "Master Bedroom Designs", desc: "Personalized bedrooms combining comfort and style.", icon: <FaBed /> },
    { title: "Living Room Designs", desc: "Modern, inviting living spaces for family gatherings.", icon: <FaCouch /> },
    { title: "Pooja Room Designs", desc: "Peaceful pooja rooms designed with elegance and devotion.", icon: <FaDrawPolygon /> },
    { title: "TV Unit Designs", desc: "Contemporary TV units that fit your living space perfectly.", icon: <FaTv /> },
    { title: "False Ceiling Designs", desc: "Artistic ceiling designs that enhance room ambiance.", icon: <FaLayerGroup /> },
    { title: "Kids Bedroom Designs", desc: "Playful and creative kids’ rooms with smart layouts.", icon: <FaChild /> },
    { title: "Balcony Designs", desc: "Beautiful balconies designed for comfort and outdoor living.", icon: <FaCloudSun /> },
    { title: "Dining Room Designs", desc: "Elegant dining rooms built for connection and comfort.", icon: <FaChair /> },
    { title: "Foyer Designs", desc: "Warm foyers that make lasting first impressions.", icon: <FaDoorOpen /> },
    { title: "Homes By Livspace", desc: "Complete home interiors crafted for your lifestyle.", icon: <FaHome /> },
    { title: "Home Office Designs", desc: "Functional home offices with stylish organization.", icon: <FaChalkboardTeacher /> },
    { title: "Guest Bedroom Designs", desc: "Cozy, inviting guest rooms with refined decor.", icon: <FaBed /> },
    { title: "Window Designs", desc: "Elegant window designs that maximize light and beauty.", icon: <FaWindowMaximize /> },
    { title: "Flooring Designs", desc: "Durable, attractive flooring for every interior style.", icon: <FaRulerCombined /> },
    { title: "Wall Decor Designs", desc: "Creative wall decor that adds depth and character.", icon: <FaDrawPolygon /> },
    { title: "Wall Paint Designs", desc: "Trendy wall paint ideas with texture and mood.", icon: <FaPaintBrush /> },
    { title: "Home Wallpaper Designs", desc: "Beautiful wallpapers that personalize your space.", icon: <FaPalette /> },
    { title: "Tile Designs", desc: "High-quality tiles that enhance both style and durability.", icon: <FaBorderStyle /> },
    { title: "Study Room Designs", desc: "Peaceful, creative study rooms designed for focus.", icon: <FaChalkboardTeacher /> },
    { title: "Kitchen Sinks", desc: "Elegant and durable kitchen sinks for modern homes.", icon: <FaUtensils /> },
    { title: "Space Saving Designs", desc: "Smart multi-functional designs to optimize space.", icon: <FaCubes /> },
    { title: "Door Designs", desc: "Premium door styles combining aesthetics and strength.", icon: <FaDoorOpen /> },
    { title: "Staircase Designs", desc: "Stylish staircases that add architectural beauty.", icon: <GiStairs /> },
    { title: "Crockery Units", desc: "Elegant crockery units for organized dining storage.", icon: <FaBoxOpen /> },
    { title: "Home Bar Designs", desc: "Modern bar setups designed for luxury and leisure.", icon: <FaWineGlassAlt /> },
  ];

  return (
    <div className="how-we-work-list grid-container">
      {services.map((item, index) => {
        const animationClass = animations[index % animations.length];
        return (
          <div className={`how-we-work-item ${animationClass}`} key={index}>
            <div className="icon-box">{item.icon}</div>
            <div className="how-we-work-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HomeServices;
